import React, { useMemo } from 'react';
import Table from '../Components/Tables';

const ThematicExpandableRow = ({ data }) => {
  const thematics = data?.thematic || [];

  console.log('Thematics:', thematics);

  const innerColumns = useMemo(
    () => [
      { name: 'Thematic', selector: (r) => r.name, sortable: true },
      { name: 'Counter', selector: (r) => r.counter, sortable: true },
      { name: 'Generated', selector: (r) => r.count_generate, sortable: true },
      { name: 'Sent', selector: (r) => r.count_sent, sortable: true },
      { name: 'Redacted', selector: (r) => r.count_redacted, sortable: true },
    ],
    [],
  );

  const innerRows = useMemo(
    () =>
      thematics.map((t, idx) => ({
        id: t?.thematic?.key || `${idx}`,
        name: t?.thematic?.name ?? 'No thematic',
        counter: t?.counter ?? 0,
        count_generate: t?.count_generate ?? 0,
        count_sent: t?.count_sent ?? 0,
        count_redacted: t?.count_redacted ?? 0,
      })),
    [thematics],
  );

  if (!innerRows.length) {
    return (
      <div className="table-folded-content" style={{ padding: '8px 12px' }}>
        <em>No thematics</em>
      </div>
    );
  }

  return (
    <div className="table-folded-content" style={{ padding: '8px 12px' }}>
      <Table
        title=""
        columns={innerColumns}
        data={innerRows}
        pagination={false}
        noTableHead={false}
        dense
      />
    </div>
  );
};

export default ThematicExpandableRow;
